<template>
  <div>
    <h6 class="has-text-weight-bold mt-4 text-base text-gray-500">
      {{ value.label }} :
    </h6>
    <p v-html="value.value.address"></p>
  </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
  name: 'PreviewLocationAttribute',
  props: ['value'],
}
</script>

<style scoped></style>
